import AnimatedPageTransition from "../../../../../domain/module/navigation/animated-page-transition";
import { TourLocalMap } from "./tour-local-map";

const MapPage = () => {
  return (
    <AnimatedPageTransition>
      <TourLocalMap />
    </AnimatedPageTransition>
  );
};

export default MapPage;
